import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import StarryBackground from './components/StarryBackground';
import LanguageSwitcher from './components/LanguageSwitcher';
import IntroSection from './components/IntroSection';
import SkillsSection from './components/SkillsSection';
import ProjectsSection from './components/ProjectsSection';
import ContactSection from './components/ContactSection';
import Player from './components/Player';
import CS2 from './components/cs2/CS2';
import TestInventory from './components/cs2/TestInventory';
import SimpleInventoryTest from './components/cs2/SimpleInventoryTest';
import Weather from './components/weather/Weather';
import Snake from './components/snake/Snake';
import Pong from './components/pong/Pong';
import Football from './components/football/Football';
import StorkKiller from './components/storkKiller/StorkKiller';
import StorkKiller3D from './components/storkKiller3D/StorkKiller3D';
import QuizCS from './components/quizcs/QuizCS';
import RomaFredGame from './components/romaFredGame/RomaFredGame';
import { useLanguage } from './hooks/useLanguage';
import './App.css';

function App() {
  const { currentLanguage, changeLanguage, t } = useLanguage();

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              <div className="hero-section">
                <StarryBackground />
                <LanguageSwitcher 
                  currentLanguage={currentLanguage} 
                  onLanguageChange={changeLanguage} 
                />
                <IntroSection t={t} />
              </div>
              <SkillsSection t={t} />
              <ProjectsSection t={t} />
              <ContactSection t={t} />
            </>
          } />
          <Route path="/player" element={<Player />} />
          <Route path="/cs2" element={<CS2 />} />
          <Route path="/test-inventory" element={<TestInventory />} />
          <Route path="/simple-test" element={<SimpleInventoryTest />} />
          <Route path="/weather" element={<Weather />} />
          <Route path="/snake" element={<Snake />} />
          <Route path="/pong" element={<Pong />} />
          <Route path="/football" element={<Football />} />
          <Route path="/storkKiller" element={<StorkKiller />} />
          <Route path="/storkKiller3D" element={<StorkKiller3D />} />
          <Route path="/storkkiller3d" element={<StorkKiller3D />} />
          <Route path="/quizcs" element={<QuizCS />} />
          <Route path="/RomaFredGame" element={<RomaFredGame />} />
          <Route path="/romafredgame" element={<RomaFredGame />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;